import {useEffect} from "react";
import {useAppDispatch} from "../app/hooks";
import {RequestStatus} from "../api/apiConfiguration";
import {showErrorToastNotification} from "../components/elements/toastNotification/toastNotificationSlice";

/**
 * Shows an error toast when a request ends up rejected.
 *
 * Dropdown option loads used to fail silently: the thunk recorded REJECTED but nothing read it, so
 * a filter simply rendered empty and the operator had no idea the data was missing. This keeps the
 * reporting in one place instead of repeating the same effect at every call site.
 *
 * @param status  the request status to watch
 * @param message what to tell the operator when it fails
 */
export const useRequestErrorToast = (status: RequestStatus, message: string): void => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (status === RequestStatus.REJECTED) {
            dispatch(showErrorToastNotification({message}));
        }
    }, [status, message, dispatch]);
};
